

const API_ENDPOINT_URL = import.meta.env.VITE_API_ENDPOINT_URL;
const API_VERSION = import.meta.env.VITE_API_VERSION;
const BACKEND_ENDPOINT_URL = import.meta.env.VITE_BACKEND_ENDPOINT_URL;
const BACKEND_VERSION = import.meta.env.VITE_BACKEND_VERSION;

const Config = {
  API_URL: API_ENDPOINT_URL + API_VERSION,
  BACKEND_URL: BACKEND_ENDPOINT_URL + BACKEND_VERSION, 
  IN_PROD: import.meta.env.MODE === 'production',
  IN_DEV: import.meta.env.MODE === 'development',
  IN_REMOTE: import.meta.env.MODE === 'remote',
  API_ENDPOINT_URL,
  API_VERSION,
  BACKEND_ENDPOINT_URL,
  BACKEND_VERSION,
  LOCAL_STORAGE_KEY: import.meta.env.VITE_LOCAL_STORAGE_KEY,
  INVITATION_STATUSES:["pending", "accepted", "revoked","read","joined","declined"],
};

console.log('=== Config === config.js === key: 412965 ===');
console.dir(Config, { depth: null, colors: true })
console.log('=================================');
console.log('Backend URL:', Config.BACKEND_URL);


export default Config;
